// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Component_Clone = require("../Lunarbox.Component.Clone/index.js");
var Lunarbox_Component_HOC_Connect = require("../Lunarbox.Component.HOC.Connect/index.js");
var Lunarbox_Component_Home = require("../Lunarbox.Component.Home/index.js");
var Lunarbox_Component_Login = require("../Lunarbox.Component.Login/index.js");
var Lunarbox_Component_Project = require("../Lunarbox.Component.Project/index.js");
var Lunarbox_Component_Projects = require("../Lunarbox.Component.Projects/index.js");
var Lunarbox_Component_Register = require("../Lunarbox.Component.Register/index.js");
var Lunarbox_Component_Tutorial = require("../Lunarbox.Component.Tutorial/index.js");
var Lunarbox_Component_TutorialEditor = require("../Lunarbox.Component.TutorialEditor/index.js");
var Lunarbox_Config = require("../Lunarbox.Config/index.js");
var Lunarbox_Control_Monad_Effect = require("../Lunarbox.Control.Monad.Effect/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Record = require("../Record/index.js");
var Routing_Duplex_Parser = require("../Routing.Duplex.Parser/index.js");
var Navigate = (function () {
    function Navigate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Navigate.create = function (value0) {
        return function (value1) {
            return new Navigate(value0, value1);
        };
    };
    return Navigate;
})();
var Initialize = (function () {
    function Initialize() {

    };
    Initialize.value = new Initialize();
    return Initialize;
})();
var Logout = (function () {
    function Logout() {

    };
    Logout.value = new Logout();
    return Logout;
})();
var NavigateTo = (function () {
    function NavigateTo(value0) {
        this.value0 = value0;
    };
    NavigateTo.create = function (value0) {
        return new NavigateTo(value0);
    };
    return NavigateTo;
})();
var Receive = (function () {
    function Receive(value0) {
        this.value0 = value0;
    };
    Receive.create = function (value0) {
        return new Receive(value0);
    };
    return Receive;
})();
var noAuth = [ Lunarbox_Data_Route.Login.value, Lunarbox_Data_Route.Register.value ];
var component = function (dictMonadAff) {
    return function (dictMonadEffect) {
        return function (dictNavigate) {
            return function (dictMonadReader) {
                return function (dictManageTutorials) {
                    return function (dictManageProjects) {
                        return function (dictManageGists) {
                            return function (dictManageUser) {
                                var notFound = Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("404 - Page not found") ]);
                                var handleQuery = function (v) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Data_Maybe.eqMaybe(Lunarbox_Data_Route.eqRoute))(v1.route)(new Data_Maybe.Just(v.value0)))(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                            var $21 = {};
                                            for (var $22 in v2) {
                                                if ({}.hasOwnProperty.call(v2, $22)) {
                                                    $21[$22] = v2[$22];
                                                };
                                            };
                                            $21.route = new Data_Maybe.Just(v.value0);
                                            return $21;
                                        })))(function () {
                                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                                        });
                                    });
                                };
                                var handleAction = function (v) {
                                    if (v instanceof Initialize) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_Reader_Class.asks(Halogen_Query_HalogenM.monadAskHalogenM(dictMonadReader.MonadAsk0()))(Data_Lens_Getter.view(Lunarbox_Config["_locationState"](Data_Lens_Internal_Forget.strongForget))))(function (getLocationState) {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(getLocationState))(function (v1) {
                                                var v2 = Lunarbox_Data_Route.parseRoute(v1.path);
                                                if (v2 instanceof Data_Either.Left) {
                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Control_Monad_Effect.printString(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))("An error occured trying to parse the curent route. Defaulting to Home. " + Data_Show.show(Routing_Duplex_Parser.showRouteError)(v2.value0)))(function () {
                                                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(Lunarbox_Data_Route.Home.value);
                                                    });
                                                };
                                                if (v2 instanceof Data_Either.Right) {
                                                    return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(v2.value0);
                                                };
                                                throw new Error("Failed pattern match at Lunarbox.Component.Router (line 106, column 7 - line 110, column 38): " + [ v2.constructor.name ]);
                                            });
                                        });
                                    };
                                    if (v instanceof Receive) {
                                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Record.merge()()(v.value0));
                                    };
                                    if (v instanceof NavigateTo) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                                            return Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Data_Maybe.eqMaybe(Lunarbox_Data_Route.eqRoute))(v1.route)(new Data_Maybe.Just(v.value0)) || Data_Maybe.isJust(v1.currentUser) && Data_Maybe.isJust(Data_Foldable.find(Data_Foldable.foldableArray)(function (v2) {
                                                return Data_Eq.eq(Lunarbox_Data_Route.eqRoute)(v2)(v.value0);
                                            })(noAuth)))(Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(v.value0));
                                        });
                                    };
                                    if (v instanceof Logout) {
                                        return Lunarbox_Capability_Navigate.logout(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate));
                                    };
                                    throw new Error("Failed pattern match at Lunarbox.Component.Router (line 102, column 18 - line 117, column 21): " + [ v.constructor.name ]);
                                };
                                var authorize = function (mbProfile) {
                                    return function (html) {
                                        if (mbProfile instanceof Data_Maybe.Nothing) {
                                            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "login";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Login.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictManageUser)(dictNavigate))({
                                                redirect: false
                                            })(Data_Void.absurd);
                                        };
                                        if (mbProfile instanceof Data_Maybe.Just) {
                                            return html;
                                        };
                                        throw new Error("Failed pattern match at Lunarbox.Component.Router (line 131, column 30 - line 133, column 19): " + [ mbProfile.constructor.name ]);
                                    };
                                };
                                var render = function (v) {
                                    var requireAuthorization = authorize(v.currentUser);
                                    return Data_Maybe.fromMaybe(notFound)(Data_Functor.mapFlipped(Data_Maybe.functorMaybe)(v.route)(function (v1) {
                                        if (v1 instanceof Lunarbox_Data_Route.Home) {
                                            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "home";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Home.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictMonadReader.MonadAsk0())(dictNavigate))({})(Data_Void.absurd);
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Login) {
                                            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "login";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Login.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictManageUser)(dictNavigate))({
                                                redirect: true
                                            })(Data_Void.absurd);
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Register) {
                                            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "register";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Register.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictNavigate)(dictManageUser))(Data_Unit.unit)(Data_Void.absurd);
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Projects) {
                                            return requireAuthorization(Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "projects";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Projects.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictManageProjects)(dictManageTutorials)(dictMonadReader.MonadAsk0())(dictNavigate))({})(Data_Void.absurd));
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Clone) {
                                            return requireAuthorization(Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "clone";
                                            }))(Lunarbox_Data_ProjectId.ordProjectID)(Data_Symbol.SProxy.value)(v1.value0)(Lunarbox_Component_Clone.component(dictManageProjects)(dictNavigate))({
                                                targetId: v1.value0
                                            })(Data_Void.absurd));
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Project) {
                                            return requireAuthorization(Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "project";
                                            }))(Lunarbox_Data_ProjectId.ordProjectID)(Data_Symbol.SProxy.value)(v1.value0)(Lunarbox_Component_Project.component(dictMonadAff.MonadEffect0())(dictMonadAff)(dictMonadReader.MonadAsk0())(dictMonadReader)(dictManageProjects)(dictNavigate))({
                                                id: v1.value0
                                            })(Data_Void.absurd));
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.Tutorial) {
                                            return requireAuthorization(Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "tutorial";
                                            }))(Lunarbox_Data_Tutorial.ordTutorialId)(Data_Symbol.SProxy.value)(v1.value0)(Lunarbox_Component_Tutorial.component(dictMonadAff.MonadEffect0())(dictMonadReader)(dictMonadAff)(dictNavigate)(dictManageGists)(dictManageProjects)(dictManageTutorials))({
                                                id: v1.value0
                                            })(Data_Void.absurd));
                                        };
                                        if (v1 instanceof Lunarbox_Data_Route.EditTutorial) {
                                            return requireAuthorization(Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                                return "editTutorial";
                                            }))(Lunarbox_Data_Tutorial.ordTutorialId)(Data_Symbol.SProxy.value)(v1.value0)(Lunarbox_Component_TutorialEditor.component(dictMonadAff)(dictManageProjects)(dictManageTutorials)(dictNavigate))({
                                                id: v1.value0
                                            })(Data_Void.absurd));
                                        };
                                        throw new Error("Failed pattern match at Lunarbox.Component.Router (line 141, column 11 - line 149, column 131): " + [ v1.constructor.name ]);
                                    }));
                                };
                                return Lunarbox_Component_HOC_Connect.component(dictMonadAff)(dictMonadReader.MonadAsk0())()(Halogen_Component.mkComponent({
                                    initialState: Data_Function["const"]({
                                        route: Data_Maybe.Nothing.value,
                                        currentUser: Data_Maybe.Nothing.value
                                    }),
                                    render: render,
                                    "eval": Halogen_Component.mkEval({
                                        handleAction: handleAction,
                                        handleQuery: handleQuery,
                                        receive: function ($48) {
                                            return Data_Maybe.Just.create(Receive.create($48));
                                        },
                                        initialize: new Data_Maybe.Just(Initialize.value),
                                        finalize: Halogen_Component.defaultEval.finalize
                                    })
                                }));
                            };
                        };
                    };
                };
            };
        };
    };
};
module.exports = {
    component: component,
    Navigate: Navigate
};
